module.exports = __webpack_public_path__ + "img/icon_map_5_hg_c.9ece5a6e.png";